import { cn } from '@/lib/utils'
import { AlertTriangle, XCircle } from 'lucide-react'

interface Props {
  status: 'Failed' | 'Cancelled'
  errorSummary: string | null
}

export function ChainStoppedBanner({ status, errorSummary }: Props) {
  const isFailed = status === 'Failed'
  const Icon = isFailed ? AlertTriangle : XCircle
  const title = isFailed ? 'Chain failed' : 'Chain cancelled'
  const fallback = isFailed
    ? 'The chain stopped with an error. Review the last link that ran for details.'
    : 'The chain was cancelled. Links that had not started were skipped.'
  const textClass = isFailed ? 'text-danger-foreground' : 'text-cancelled-foreground'

  return (
    <div role="alert" data-testid="chain-stopped-banner">
      <div className={cn('rounded-md border px-4 py-3', isFailed ? 'border-danger-foreground bg-danger' : 'border-cancelled-foreground bg-cancelled')}>
        <div className="flex items-start gap-3">
          <Icon className={cn('h-5 w-5 shrink-0 mt-0.5', textClass)} aria-hidden />
          <div className="flex-1 min-w-0">
            <p className={cn('text-sm font-semibold', textClass)}>{title}</p>
            <p className={cn('mt-1 text-sm', textClass)}>{errorSummary ?? fallback}</p>
          </div>
        </div>
      </div>
    </div>
  )
}
